import useRequest from '../useRequest'

const useUserAgent = () => useRequest().userAgent

export default useUserAgent
